import React, { forwardRef, Fragment, useContext, useEffect, useState } from 'react';
import { Controller } from '../Controller';
import { DrawerMenuDashboardMobile } from './DrawerMenuDashboardMobile';
import { css } from 'aphrodite';
import { AppTheme } from '../../styles/AppTheme';
import { AppConfig } from '../../AppConfig';
import { CustomOrgSwitcherStylesMob } from '../../styles/CustomStyles';
import { Helper } from '../helpers/Helper';
import { AppHelper } from '../../helpers/AppHelper';

export const MobileMoreMenu = forwardRef((props, ref) => {

  const [state, setState] = useState({
    selectedOrgUnitId: Controller.get().roleHelper().getOrgUnitId()
  })

  useEffect(() => {
  }, [])

  const onOrgChange = async (options) => {
    if (!options.orgUnitId) return
    setState({ ...state, selectedOrgUnitId: options.orgUnitId });
    const {orgId: selectedOrgId} = AppHelper.parseOrgUnitId(options.orgUnitId)
    Controller.get().roleHelper().setCurrentOrgInfo(selectedOrgId, options.orgUnitId)
    await Controller.get().cdpHelper().loadSettings(selectedOrgId)
    const pathname = Controller.get().roleHelper().getHome(options.orgUnitId)
    window.location.href = pathname
  }

  const orgSwitcherComp = () => {
    const options = Controller.get().userMgr().getAppUser()
    if (!options || !options.orgs || options.orgs.length === 0) {
      return <></>
    }

    return (
      <div className={css(Styles.orgSwitchContainer)}>
        <span className={css(Styles.osString)}>
          {Helper.getString('accounts')}
        </span>
        <div className={css(Styles.orgsListContainer)}>
          {AppHelper.getOrgSwitcherOrgs(options.orgs, state.selectedOrgUnitId).map((org) => (
            <div
              key={org.subOrgId || org.orgId}
              className={css(
                Styles.org,
                (org.subOrgId ? state.selectedOrgUnitId === org.subOrgId : state.selectedOrgUnitId === org.orgId) && Styles.orgActive
              )}
              onClick={() => onOrgChange({ orgUnitId: org.subOrgId || org.orgId })}
            >
              {org.title}
            </div>
          ))}
        </div>
      </div>
    )
  }

  return (
    <Fragment>
      <DrawerMenuDashboardMobile
        ref={ref}
        menuItems={[]}
        orgSwitcherComp={orgSwitcherComp}
      />
    </Fragment>
  );
})

const Styles = AppConfig.CUSTOM_STYLE ? CustomOrgSwitcherStylesMob : StyleSheet.create({
  orgSwitchContainer: {
    margin: '5px 0px',
    marginLeft: 10,
    display: 'flex',
    flexDirection: 'column',
    gap: 10
  },
  orgsListContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 10
  },
  org: {
    borderRadius: '20px',
    background: '#f5f5f5',
    padding: '5px 15px',
    fontSize: 16
  },
  orgActive: {
    background: '#2146E5',
    color: '#FFFFFF'
  },
  osString: {
    color: '#7D7D7D',
    fontSize: 14
  }
})